// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { API_SUBTIPOS_INCIDENCIAS } from "../views/MainLayout/components/shared/services/subtipos_incidencia";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialSubtiposIncidencias = []

export const subtiposIncidenciaFullfilledReducer = (state = initialSubtiposIncidencias, action) => {
  switch(action.type){
    case "subtipos_incidencia/fullfilled": {            
      return action.payload;
    }
    default:
      return state
  }
}

export const fetchSubtiposIncidencia = () => async (dispatch) => {
  dispatch({ type: 'loading/set', payload: true })

  try {
    const response = await API_SUBTIPOS_INCIDENCIAS.getSubtiposIncidencia();
    const data = await response.data;
    dispatch({ type: 'subtipos_incidencia/fullfilled', payload: data })
  } catch (e) {
    toast.error(setErrorMessage(e))
  } finally {
    dispatch({ type: 'loading/set', payload: false })
  }
};
